import { useQuery } from '@apollo/client';
import { GET_PARTNER_REQUEST } from 'graphql/secure/queries/partner.queries';
import { useParams } from 'react-router-dom';
import { IGetPartnerRequestData } from 'graphql/secure/queries/partner.queries';
import { IQuestionnaire } from 'FeatureModules/Questionnaire/types/questionnaire.types';
import { GET_QUESTIONNAIRE_OVERVIEW } from 'graphql/secure/queries/questionnaire.queries';

const usePartnerRequest = () => {
  const { requestId } = useParams<{ requestId: string | undefined }>();
  const { data, loading, error } = useQuery<IGetPartnerRequestData>(GET_PARTNER_REQUEST, {
    variables: {
      id: requestId,
    },
  });

  const {
    data: questionnaireData,
    loading: questionnaireLoading,
    error: questionnaireError,
  } = useQuery<{
    questionnaire: IQuestionnaire;
  }>(GET_QUESTIONNAIRE_OVERVIEW, {
    variables: { id: data?.partnerRequest.questionnaireId },
    skip: !data?.partnerRequest.questionnaireId,
  });

  return {
    questionnaire: questionnaireData?.questionnaire,
    partnerRequest: data?.partnerRequest,
    loading: loading || questionnaireLoading,
    error: error || questionnaireError,
  };
};

export default usePartnerRequest;
